import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: baseline;
  background-color: ${({ theme }) => theme.colors.bg.primary};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 190px;
  margin: auto;
  min-width: 250px;
  padding: 25px 0 0 25px;
  text-align: left;
  width: 250px;

  svg {
    height: 22px;
    width: 22px;
  }
`;
